<!-- MEUS ATENDIMENTOS (PÓS ATENDIMENTO)-->

<template>
<v-card class="dialog" color="grey lighten-3" height="1080px">
    <v-toolbar dark color="primary">
        <v-btn icon dark @click="$emit('fechar')">
            <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Meus pacientes</v-toolbar-title>

    </v-toolbar>

    <v-row v-if="!isExibirAtendimento" :class="isExibirAtendimento?'animated fadeOut mt-2': 'animated fadeIn mt-2'">
        <v-layout justify-center>
            <v-card width="800px" height="700">
                <v-card-title dense>
                    <v-text-field v-model="search" label="Buscar Paciente" append-icon="search"></v-text-field>
                </v-card-title>
                <v-divider />
                <v-progress-linear color="orange" v-show="load" :indeterminate="true" />
                <v-card v-if="load" color="grey lighten-4">
                    <v-list v-for="i in 10" :key="i">
                        <v-skeleton-loader type="list-item" />
                        <v-divider />
                    </v-list>
                </v-card>
                <v-list-item v-if="!load && pacientes.length == 0 && search.length > 2">
                    <v-list-item-title>
                        Nunhum resultado encontrado
                    </v-list-item-title>
                </v-list-item>
                <v-expansion-panels>
                    <v-expansion-panel v-for="(item, i) in pacientes" :key="i" @change="carregarConsultas(item.idAtendimento)">
                      <v-expansion-panel-header>
                            <v-list-item dense :key="item.os" :disabled="load">
                                <v-list-item-content>
                                    <v-list-item-title>
                                        <strong>{{ item.nomePaciente }}</strong>
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        <b>OS: </b>{{item.os}} <b>ID Paciente:</b> {{ item.idPaciente }} <b>Data de nascimento:</b> {{ formatarData(item.dataNascimento) }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </v-expansion-panel-header>

                        <v-expansion-panel-content>
                          <v-card color="grey" outlined>
                            <v-list dense>
                                <v-list-item-group>
                                    <v-list-item v-for="(consulta, index) in consultas" :key="index" :disabled="load" @click="isExibirAtendimento = true, currentSelected = item">
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                <strong>{{ consulta.nome }}</strong>
                                            </v-list-item-title>
                                            <v-list-item-subtitle v-show="consulta.dataSaida != null">
                                                <!-- Data de chegada -->
                                                <b>Chegou: </b>{{ formatarDataHora(consulta.dataChegada) }}
                                                <!-- <b>Chegou: </b>{{ formatarDataHora(consulta.dataChegada) }} <b>Saiu:</b> {{ formatarDataHora(consulta.dataSaida) }} -->
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                        <v-list-item-action>
                                            <v-spacer />
                                            <v-btn icon>
                                                <v-icon small color="primary">
                                                    mdi-open-in-new
                                                </v-icon>
                                            </v-btn>
                                        </v-list-item-action>
                                    </v-list-item>
                                </v-list-item-group>
                            </v-list>
                          </v-card>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
                <v-alert class="ma-2" v-show="search.length > 2 && pacientes.length == 0" type="info" :value="true">
                    "Desculpe, não conseguimos encontrar resultados para a sua busca. Por favor, tente procurar pela data no histórico de atendimento."
                </v-alert>
            </v-card>
        </v-layout>
    </v-row>

    <v-row>
        <v-layout justify-center>
            <v-card flat color="grey lighten-3" v-if="isExibirAtendimento" :class="isExibirAtendimento?'animated fadeIn': 'animated fadeOut'" class="mt-4">
                <historico :ficha="currentSelected" :isProntuario="false" @voltar="isExibirAtendimento = false" />
            </v-card>
        </v-layout>
    </v-row>
</v-card>
</template>

<script>
import medicoService from '../../services/medico.service'
import historico from '../medico/historico.vue'
import moment from 'moment'

export default {
  components: {
    historico
  },
  data: () => ({
    user: '',
    load: false,
    dialog: false,
    date: null,
    pacientes: [],
    consultas: [],
    isExibirAtendimento: false,
    currentSelected: '',
    search: ''
  }),
  mounted () {
    this.user = this.$store.getters.usuario
    this.carregarDataAtual()
  },
  methods: {
    formatarData (data) {
      return moment(data).format('DD/MM/YYYY')
    },
    formatarDataHora (dataHora) {
      if (dataHora == null) {
        return ''
      }
      let date = new Date(dataHora)
      let day = ('0' + date.getDate()).slice(-2)
      let month = ('0' + (date.getMonth() + 1)).slice(-2)
      let year = date.getFullYear()
      let hours = ('0' + date.getHours()).slice(-2)
      let minutes = ('0' + date.getMinutes()).slice(-2)
      return `${day}/${month}/${year} ${hours}:${minutes}`
    },
    carregarDataAtual () {
      var now = new Date()
      var year = now.getFullYear()
      var month = String(now.getMonth() + 1).padStart(2, '0')
      var day = String(now.getDate()).padStart(2, '0')
      this.date = `${year}-${month}-${day}`
      console.log('antes de chamar')
    },
    carregarConsultas (atendimento) {
      console.log(atendimento)
      medicoService.medico.buscarConultasPorAtendimento(atendimento).then(response => {
        console.log(response.data)
        this.consultas = response.data
      }).catch(error => {
        console.log(error)
      })
    },
    buscarPacienteAtendimentoPorNome (search) {
      this.load = true
      medicoService.medico.buscarPacienteAtendimentoPorNome(search, this.user.idUnidade).then(response => {
        this.pacientes = response.data
        this.load = false
      }).catch(error => {
        console.log(error)
        this.load = false
      })
    }
  },
  watch: {
    search (val) {
      console.log(val)
      if (val.length > 2) {
        this.buscarPacienteAtendimentoPorNome(val)
      } else {
        this.pacientes = []
      }
    }
  }
}
</script>

<style scoped>
</style>
